import { BaseService } from './BaseService';
import downloadjs from 'downloadjs';
import { request } from './request';

/**
 * Сервис для работы с проектными файлами
 */
export class ProjectService extends BaseService {

	/**
	 * Запрос на получение содержимого проектного файла
	 * Если параметр указан, то ПФ будет загружен из хранилища,
	 * иначе будет возвращен текущий (загруженный ) проект
	 */
	static async getProject(project) {
		const url = !!project ? `/project/getfromstorage/${project}` : "/project/get";
		const response = await this.baseHandle(url);
		if ( response.status === 200)
			return Promise.resolve(response.data);
		else 
			throw response.data ? response.data : response.message;
	}

	/**
	 * Запрос получения списка проектов из хранилища
	 */
	static async getStorage() {
		const response = await this.baseHandle("/project/getstorage"); //'Content-Type': 'application/json'

		if (response.status === 200)
			return Promise.resolve(response.data);

		throw !!response.data ? response.data : response.message;
	}

	/**
	 * Запрос загрузки проектного файла
	 */
	 static async uploadProject(uploadFormData) {
		const response = await this.baseHandle("/project/upload", "POST", null, uploadFormData, true);

		if (response.status === 200)
			return Promise.resolve(response.data);

		throw !!response.data ? response.data : response.message;
	}

	/**
	 * Запрос загрузки и активации ПФ
	 */
	 static async uploadWithInitTable(uploadFormData) {
		const response = await this.baseHandle("/project2/upload", "POST", null, uploadFormData, true);

		if (response.status === 200)
			return Promise.resolve(response.data);

		throw !!response.data ? response.data : response.message;
	}

	/**
	 * Запрос проверки версий плагинов в проектном файле
	 */
	 static async checkPluginsVersion(formData) {
		const response = await this.baseHandle("/project/checkpluginsversion", "POST", null, formData, true);

		if (response.status === 200 )
			return Promise.resolve(response);
		else if ( response.status === 400 )
			return Promise.resolve(response.data);

		throw !!response.data ? response.data : response.message;
	}

	/**
	 * Запрос сохранения проектного файла в хранилище
	 */
	static async saveToStorage(name, proj) {
		const response = await this.baseHandle(`/project/savetostorage/${name}`, "POST", {'Content-Type': 'application/json'}, JSON.stringify(proj));
		if ( response.status === 200)
			return Promise.resolve(response);
		else 
			throw response.data ? response.data : response.message;
	}

	/**
	 * Запрос загрузки проекта в систему из хранилища, архивированного в каталог Uploads
	 */
	static async uploadFromStorage(name) {
		const response = await this.baseHandle(`/project/uploadfromstorage/${name}`, "POST", {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		});
		if ( response.status === 200)
			return Promise.resolve(response);
		else 
			throw response.data ? response.data : response.message;
	}

	/**
	 * Запрос на создание ПФ
	 */
	static async createProject(name, type) {
		const response = await this.baseHandle(`/project/create/${name}/${type}`, "POST", {'Content-Type': 'application/json'});
		if ( response.status === 200)
			return Promise.resolve(response);
		else 
			throw response.data ? response.data : response.message;
	}

	/**
	 * Запрос для скачивания проекта
	 */
	static async downloadProject(projectName) {
		const response = await this.baseHandle(`/project/download/${projectName}`);
		if ( response.status === 200)
			return Promise.resolve(response);
		else 
			throw response.data ? response.data : response.message;
	}

	/**
	 * Скачивание проектного файла
	 */
	static async downloadProjectFile(projectName) {
		return this.downloadProject(projectName)
			.then( data => downloadjs(data.data, `${projectName}.zip`) );
	}

	/**
	 * Запрос загрузки проекта в систему из каталога загрузок (ранее загруженного туда из удаленного источника)
	 */
	static async checkPluginsVersionFromUploadedFile(fileName) {
		const response = await this.baseHandle(`/project/CheckPluginsVersionFromUploadedFile/${fileName}`, "POST", {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		});

		if (response.status === 200 )
			return Promise.resolve(response);
		else if ( response.status === 400 )
			return Promise.resolve(response.data);

		throw !!response.data ? response.data : response.message;
	}

	/**
	 * Запрос загрузки проектного файла ранее уже загруженного в каталог Uploads
	 */
	static async uploadFromUploadedFile(localFileName) {
		const response = await this.baseHandle(`/project/UploadFromUploadedFile/${localFileName}`, "POST", {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		});
		if (response.status === 200)
			return Promise.resolve(response.data);

		throw !!response.data ? response.data : response.message;
	}

	/**
	 * Запрос удаления проекта из хранилища
	 */
	static async deleteProject(name) {
		const response = await this.baseHandle( `/project/delete/${name}`, "DELETE" );
		if ( response.status === 200)
			return Promise.resolve(response);
		else 
			throw response.data ? response.data : response.message;
	}

	/**
	 * Запрос загрузки проекного файла из удаленного репозитория
	 */
	static async uploadProjectFromRemoteRepository(data) {
		const response = await this.baseHandle("/project/UploadProjectFromRemoteRepository", "PATCH", null, data );

		if ( response.status === 200)
			return Promise.resolve(response);
		else 
			throw response.data ? response.data : response.message;
	}

	/* Старые методы для совместимости. TODO: Удалить неиспользуемые! */
	
	/**
	 * Получение списка загруженных проектов
	 */
	static get = async () => await request.get('/project/getstorage');

	/**
	 * Создание нового проекта
	 * @param {string} name 
	 * @param {string} type 
	 */
	static create = async (name, type) => await request.post(`/project/create/${name}/${type}`);

	/**
	 * Проверка версий плагинов загружаемого проекта
	 * @param {File} file Файл проекта
	 */
	static checkPlugin = async (file) => {
		const formData = new FormData();
		formData.append("file", file);
		return await request.uploadFile("/project/checkpluginsversion", formData);
	};

	/**
	 * Удаление проекта
	 * @param {string} projectName Наименование проекта
	 */
	static remove = async (projectName) => await request.delete(`/project/delete/${projectName}`);

	/**
	 * Загрузка проекта
	 * @param {File} file Проектный файл
	 */
	static uploadLocal = async (file) => {
		const formData = new FormData();
		formData.append("file", file);
		return await request.uploadFile("/project/upload", formData);
	};

	/**
	 *  Загрузка проекта с инициализацией системных таблиц
	 * @param {File} file Проектный файл
	 */
	static uploadLocalWithInitTable = async (file) => {
		const formData = new FormData();
		formData.append("file", file);
		return await request.uploadFile("/project2/upload", formData);
	};

	/**
	 * Загрузка проекта в систему
	 * @param {string} name Наименование проекта
	 */
	static upload = async (name) => await request.post(`/project/uploadfromstorage/${name}`);

	/**
	 * Проверка версий плагинов загружаемого проекта из удаленного источника
	 * @param {string} fileName 
	 */
	static checkPluginsFromUploadedFile = async (fileName) => await request.post(`/project/CheckPluginsVersionFromUploadedFile/${fileName}`);

	/**
	 * Загрузка проекта из удаленного источника
	 * @param {string} fileName Наименование файла
	 */
	static UploadFromUploadedFile = async (fileName) => await request.post(`/project/UploadFromUploadedFile/${fileName}`);

}

export default ProjectService;
